(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash/fp/defaults"), require("lodash/fp/get"), require("lodash/fp/has"), require("lodash/fp/set"), require("lodash/fp/omit"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash/fp/defaults", "lodash/fp/get", "lodash/fp/has", "lodash/fp/set", "lodash/fp/omit"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("lodash/fp/defaults"), require("lodash/fp/get"), require("lodash/fp/has"), require("lodash/fp/set"), require("lodash/fp/omit")) : factory(root["React"], root["lodash/fp/defaults"], root["lodash/fp/get"], root["lodash/fp/has"], root["lodash/fp/set"], root["lodash/fp/omit"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__17__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return Checkbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Email", function() { return Email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hidden", function() { return Hidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Number", function() { return Number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Password", function() { return Password; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return Radio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Textarea", function() { return Textarea; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _lib_convert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _components_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return _components_Form__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _components_FormContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormContext", function() { return _components_FormContext__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return _components_Input__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _components_InputGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return _components_InputGroup__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _hooks_useError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useError", function() { return _hooks_useError__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _hooks_useForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useForm", function() { return _hooks_useForm__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _hooks_useFormContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useFormContext", function() { return _hooks_useFormContext__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _hooks_useRegister__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useRegister", function() { return _hooks_useRegister__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _hooks_useRegisterInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useRegisterInput", function() { return _hooks_useRegisterInput__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _hooks_useRegisterInputGroup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useRegisterInputGroup", function() { return _hooks_useRegisterInputGroup__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _hooks_useUnmountedRef__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useUnmountedRef", function() { return _hooks_useUnmountedRef__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _hooks_useValue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useValue", function() { return _hooks_useValue__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _hoc_withError__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withError", function() { return _hoc_withError__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _hoc_withValue__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withValue", function() { return _hoc_withValue__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _hoc_withValues__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withValues", function() { return _hoc_withValues__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toFloat", function() { return _lib_convert__WEBPACK_IMPORTED_MODULE_2__["toFloat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toInt", function() { return _lib_convert__WEBPACK_IMPORTED_MODULE_2__["toInt"]; });

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




















const Checkbox = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "checkbox"
}, props));
const Email = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "email"
}, props));
const Hidden = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "hidden"
}, props));
const Number = ({
  convert = _lib_convert__WEBPACK_IMPORTED_MODULE_2__["toFloat"],
  ...props
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "number",
  convert: convert
}, props));
const Password = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "password"
}, props));
const Radio = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "radio"
}, props));
const Select = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "select"
}, props));
const Text = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "input",
  type: "text"
}, props));
const Textarea = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_Input__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
  component: "textarea"
}, props));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useFormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _hooks_useRegisterInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





const Input = ({
  context,
  component = 'input',
  ...props
}) => {
  const Component = component;
  const inputRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  props = Object(_hooks_useRegisterInput__WEBPACK_IMPORTED_MODULE_2__["default"])(inputRef, context, props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({
    ref: inputRef
  }, props));
};

const Input_ = props => {
  const context = Object(_hooks_useFormContext__WEBPACK_IMPORTED_MODULE_1__["default"])();
  const value = context.getRawValue(props.name);
  const touched = context.getTouched(props.name);
  const disabled = props.disabled || context.options.disableOnSubmit && context.isSubmitting;
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(() => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Input, _extends({}, props, {
    disabled: disabled,
    context: context
  })), [props, value, touched, disabled] // eslint-disable-line react-hooks/exhaustive-deps
  );
};

/* harmony default export */ __webpack_exports__["default"] = (Input_);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_FormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);



const useFormContext = () => Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_components_FormContext__WEBPACK_IMPORTED_MODULE_1__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (useFormContext);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const FormContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext();
/* harmony default export */ __webpack_exports__["default"] = (FormContext);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lib_inputProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _lib_validateInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);




const useRegisterInput = (inputRef, context, {
  removeValue,
  convert,
  validate,
  ...props
}) => {
  const newProps = { ...props
  };
  Object(_lib_inputProps__WEBPACK_IMPORTED_MODULE_1__["addValueProps"])(newProps, context);
  Object(_lib_inputProps__WEBPACK_IMPORTED_MODULE_1__["addEventProps"])(newProps, context);
  Object(_lib_inputProps__WEBPACK_IMPORTED_MODULE_1__["removeDefaultProps"])(newProps);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => {
    const defaultValue = Object(_lib_inputProps__WEBPACK_IMPORTED_MODULE_1__["getDefaultValue"])(props, inputRef.current);
    context.register({
      name: props.name,
      defaultValue,
      validate: Object(_lib_validateInput__WEBPACK_IMPORTED_MODULE_2__["default"])(inputRef, validate),
      convert
    });
    return () => context.unregister(props.name, removeValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return newProps;
};

/* harmony default export */ __webpack_exports__["default"] = (useRegisterInput);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultValue", function() { return getDefaultValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addValueProps", function() { return addValueProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEventProps", function() { return addEventProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeDefaultProps", function() { return removeDefaultProps; });
const getDefaultValue = (props, input) => {
  const {
    value,
    type,
    defaultValue,
    defaultChecked
  } = props;
  if (type === 'checkbox') return !!defaultChecked;
  if (type === 'radio') return defaultChecked ? String(value) : undefined;
  if (input.tagName === 'SELECT' && defaultValue == null) return input.value;
  return defaultValue == null ? '' : String(defaultValue);
};
const addValueProps = (props, context) => {
  const {
    name,
    value,
    type
  } = props;
  const contextValue = context.getRawValue(name);

  if (type === 'checkbox') {
    props.checked = contextValue === 0 ? true : !!contextValue;
  } else if (type === 'radio') {
    props.checked = value === contextValue;
  } else {
    props.value = contextValue == null ? '' : String(contextValue);
  }
};
const addEventProps = (props, context) => {
  const {
    name,
    type,
    onChange,
    onBlur,
    onClick
  } = props;

  props.onChange = event => {
    const value = type === 'checkbox' ? event.target.checked : event.target.value;
    context.setValue(name, value);
    onChange && onChange(event);
  };

  if (context.getTouched(name)) return;

  props.onBlur = event => {
    context.setTouched(name);
    onBlur && onBlur(event);
  };

  if (type === 'radio' || type === 'checkbox') {
    props.onClick = event => {
      context.setTouched(name);
      onClick && onClick(event);
    };
  }
};
const removeDefaultProps = props => {
  delete props.defaultValue;
  delete props.defaultChecked;
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// For possible values see:
// https://developer.mozilla.org/docs/Web/API/ValidityState.
const inputError = input => {
  const {
    value,
    type,
    validity,
    required
  } = input;
  const {
    valid
  } = validity; // Required strings containing only spaces are not valid

  if (valid && required && typeof value === 'string' && !value.trim()) {
    return 'valueMissing';
  }

  if (valid) return undefined;

  if (type === 'number' && !value && validity.badInput) {
    return required ? 'valueMissing' : undefined;
  }

  for (const key in validity) {
    if (validity[key]) return key;
  }
}; // An input may have more than one error but only one will be returned.


const validateInput = (inputRef, validate) => value => validate && validate(value) || inputError(inputRef.current);

/* harmony default export */ __webpack_exports__["default"] = (validateInput);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toFloat", function() { return toFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toInt", function() { return toInt; });
const toFloat = value => value == null || value === '' ? null : Number(value);
const toInt = value => value == null || value === '' ? null : Math.round(Number(value));

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _FormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _hooks_useForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





const Form = ({
  initialValues,
  disableOnSubmit,
  removeValue,
  debug,
  onChange,
  onSubmit,
  ...props
}, ref) => {
  const options = {
    disableOnSubmit,
    removeValue,
    debug
  };
  const context = Object(_hooks_useForm__WEBPACK_IMPORTED_MODULE_2__["default"])(initialValues, options);
  const isValid = context.isValid;
  const rawValues = context.getRawValues();
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => {
    onChange && onChange(context.getValues(), context);
  }, [isValid, rawValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_FormContext__WEBPACK_IMPORTED_MODULE_1__["default"].Provider, {
    value: { ...context
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("form", _extends({
    ref: ref
  }, props, {
    onSubmit: context.handleSubmit(onSubmit)
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.forwardRef(Form));

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_fp_defaults__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/* harmony import */ var lodash_fp_defaults__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_defaults__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_convertValues__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _hooks_useFlatState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _hooks_useNestedState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18);
/* harmony import */ var _hooks_useUnmountedRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19);






const defaultOptions = {
  disableOnSubmit: false,
  removeValue: false,
  debug: false
};
const defaultSubmitOptions = {
  submitInvalid: false
};

const useForm = (initialValues = {}, options = {}) => {
  const validateRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])({});
  const convertRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])({});
  const unmountedRef = Object(_hooks_useUnmountedRef__WEBPACK_IMPORTED_MODULE_5__["default"])();
  const [values, _getValue, _setValue, setDefaultValue] = Object(_hooks_useNestedState__WEBPACK_IMPORTED_MODULE_4__["default"])(initialValues);
  const [errors, getError, setError] = Object(_hooks_useFlatState__WEBPACK_IMPORTED_MODULE_3__["default"])({});
  const [touched, getTouched, _setTouched] = Object(_hooks_useFlatState__WEBPACK_IMPORTED_MODULE_3__["default"])({});
  const [isSubmitting, setIsSubmitting] = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false);
  const [isSubmitted, setIsSubmitted] = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false);
  const isValid = !Object.values(errors).some(Boolean);
  options = lodash_fp_defaults__WEBPACK_IMPORTED_MODULE_1___default()(defaultOptions, options);

  const validateValue = (name, value) => validateRef.current[name] && setError(name, validateRef.current[name](value));

  const getRawValues = () => values;

  const getRawValue = _getValue;

  const getValues = () => Object(_lib_convertValues__WEBPACK_IMPORTED_MODULE_2__["default"])(convertRef, values);

  const getValue = name => convertRef.current[name] ? convertRef.current[name](_getValue(name)) : _getValue(name);

  const setValue = (name, value) => {
    _setValue(name, value);

    validateValue(name, value);
  };

  const getErrors = () => errors;

  const setTouched = name => _setTouched(name, true);

  const register = async ({
    name,
    value,
    defaultValue,
    validate,
    convert
  }) => {
    if (validate) validateRef.current[name] = validate;
    if (convert) convertRef.current[name] = convert;

    if (value == null) {
      value = await setDefaultValue(name, defaultValue);
      validateValue(name, value);
    } else {
      setValue(name, value);
    }
  };

  const unregister = (name, removeValue = options.removeValue) => {
    setError(name, undefined);

    _setTouched(name, undefined);

    removeValue && _setValue(name, undefined);
    delete validateRef.current[name];
    delete convertRef.current[name];
  };

  const handleSubmit = (onSubmit, options = {}) => async event => {
    options = lodash_fp_defaults__WEBPACK_IMPORTED_MODULE_1___default()(defaultSubmitOptions, options);
    event && event.preventDefault();

    if ((isValid || options.submitInvalid) && !isSubmitting && onSubmit) {
      setIsSubmitting(true);

      try {
        await onSubmit(getValues());
      } finally {
        unmountedRef.current || setIsSubmitting(false);
      }
    }

    unmountedRef.current || isSubmitted || setIsSubmitted(true);
  };

  options.debug && console.log('DEBUG di-form-hooks', {
    rawValues: values,
    values: getValues(),
    errors,
    touched,
    isValid,
    isSubmitting,
    isSubmitted,
    options
  });
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(() => ({
    isValid,
    isSubmitting,
    isSubmitted,
    options,
    getRawValues,
    getRawValue,
    getValues,
    getValue,
    getErrors,
    getError,
    getTouched,
    setValue,
    setError,
    setTouched,
    register,
    unregister,
    handleSubmit // eslint-disable-next-line react-hooks/exhaustive-deps

  }), [isValid, isSubmitting, isSubmitted, values, errors, touched]);
};

/* harmony default export */ __webpack_exports__["default"] = (useForm);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__11__;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_fp_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
/* harmony import */ var lodash_fp_has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_has__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_set__WEBPACK_IMPORTED_MODULE_2__);




const convertValues = (convertRef, _values) => {
  let values = _values;
  Object.entries(convertRef.current).forEach(([name, convert]) => {
    values = lodash_fp_has__WEBPACK_IMPORTED_MODULE_1___default()(name, values) ? lodash_fp_set__WEBPACK_IMPORTED_MODULE_2___default()(name, convert(lodash_fp_get__WEBPACK_IMPORTED_MODULE_0___default()(name, values)), values) : values;
  });
  return values;
};

/* harmony default export */ __webpack_exports__["default"] = (convertValues);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_fp_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var lodash_fp_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_omit__WEBPACK_IMPORTED_MODULE_1__);



const useFlatState = initialState => {
  const [state, setState] = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(initialState);

  const getFlatState = name => state[name];

  const setFlatState = (name, value) => setState(state => {
    if (state[name] === value) return state;
    if (value === undefined) return lodash_fp_omit__WEBPACK_IMPORTED_MODULE_1___default()(name, state);
    return { ...state,
      [name]: value
    };
  });

  return [state, getFlatState, setFlatState];
};

/* harmony default export */ __webpack_exports__["default"] = (useFlatState);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp_has__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var lodash_fp_has__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_has__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_set__WEBPACK_IMPORTED_MODULE_3__);





const useNestedState = initialState => {
  const [state, setState] = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(initialState);

  const getNestedState = name => lodash_fp_get__WEBPACK_IMPORTED_MODULE_1___default()(name, state);

  const setNestedState = (name, value) => setState(state => lodash_fp_get__WEBPACK_IMPORTED_MODULE_1___default()(name, state) === value && lodash_fp_has__WEBPACK_IMPORTED_MODULE_2___default()(name, state) ? state : lodash_fp_set__WEBPACK_IMPORTED_MODULE_3___default()(name, value, state));

  const setDefaultState = async (name, defaultValue) => {
    let nextState = null;
    await setState(state => nextState = lodash_fp_get__WEBPACK_IMPORTED_MODULE_1___default()(name, state) == null ? lodash_fp_set__WEBPACK_IMPORTED_MODULE_3___default()(name, defaultValue, state) : state);
    return lodash_fp_get__WEBPACK_IMPORTED_MODULE_1___default()(name, nextState);
  };

  return [state, getNestedState, setNestedState, setDefaultState];
};

/* harmony default export */ __webpack_exports__["default"] = (useNestedState);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


const useUnmountedRef = () => {
  const unmounted = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(false);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => () => unmounted.current = true, []);
  return unmounted;
};

/* harmony default export */ __webpack_exports__["default"] = (useUnmountedRef);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useFormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _hooks_useRegisterInputGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





const InputGroup = ({
  context,
  component = 'div',
  ...props
}) => {
  const Component = component;
  props = Object(_hooks_useRegisterInputGroup__WEBPACK_IMPORTED_MODULE_2__["default"])(context, props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, props);
};

const InputGroup_ = props => {
  const context = Object(_hooks_useFormContext__WEBPACK_IMPORTED_MODULE_1__["default"])();
  const value = context.getRawValue(props.name);
  const touched = context.getTouched(props.name);
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(() => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(InputGroup, _extends({}, props, {
    context: context
  })), [props, value, touched] // eslint-disable-line react-hooks/exhaustive-deps
  );
};

/* harmony default export */ __webpack_exports__["default"] = (InputGroup_);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lib_inputGroupProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);



const useRegisterInputGroup = (context, {
  removeValue,
  convert,
  validate,
  ...props
}) => {
  const newProps = { ...props
  };
  const {
    name
  } = props;
  const value = context.getRawValue(name);
  Object(_lib_inputGroupProps__WEBPACK_IMPORTED_MODULE_1__["addEventProps"])(newProps, context);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => {
    context.register({
      name,
      convert
    });
    return () => context.unregister(name, removeValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => {
    validate && context.setError(name, validate(value));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return newProps;
};

/* harmony default export */ __webpack_exports__["default"] = (useRegisterInputGroup);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEventProps", function() { return addEventProps; });
const addEventProps = (props, context) => {
  const {
    name,
    onBlur,
    onClick
  } = props;
  if (context.getTouched(name)) return;

  props.onBlur = event => {
    context.setTouched(name);
    onBlur && onBlur(event);
  };

  props.onClick = event => {
    context.setTouched(name);
    onClick && onClick(event);
  };
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _useFormContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);


const useError = name => {
  const {
    isSubmitted,
    getError,
    getTouched
  } = Object(_useFormContext__WEBPACK_IMPORTED_MODULE_0__["default"])();

  if (isSubmitted || getTouched(name)) {
    return getError(name);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (useError);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useFormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);



const useRegister = ({
  name,
  value,
  defaultValue,
  removeValue,
  validate,
  convert
}) => {
  const {
    register,
    unregister
  } = Object(_useFormContext__WEBPACK_IMPORTED_MODULE_1__["default"])();
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(() => {
    register({
      name,
      value,
      defaultValue,
      validate,
      convert
    });
    return () => unregister(name, removeValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

/* harmony default export */ __webpack_exports__["default"] = (useRegister);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _useFormContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);


const useValue = name => {
  const {
    getValue,
    setValue
  } = Object(_useFormContext__WEBPACK_IMPORTED_MODULE_0__["default"])();

  const _setValue = value => setValue(name, value);

  return [getValue(name), _setValue];
};

/* harmony default export */ __webpack_exports__["default"] = (useValue);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




const withError = () => Component => {
  const WithError = props => {
    const error = Object(_hooks_useError__WEBPACK_IMPORTED_MODULE_1__["default"])(props.name);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(() => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({
      error: error
    }, props)), [error, props]);
  };

  WithError.displayName = `withError(${Component.displayName || Component.name})`;
  return WithError;
};

/* harmony default export */ __webpack_exports__["default"] = (withError);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





const displayName = Component => {
  const name = Component.displayName || Component.name || '';
  return name.startsWith('withValue(') ? name : `withValue(${name})`;
};

const withValue = name => Component => {
  const WithValue = props => {
    const [_value, setValue] = Object(_hooks_useValue__WEBPACK_IMPORTED_MODULE_1__["default"])(name);
    const value = _value === undefined ? null : _value;
    const valueProps = {
      [name]: value,
      [`set${Object(_lib_utils__WEBPACK_IMPORTED_MODULE_2__["capitalize"])(name)}`]: setValue
    };
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(() => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({}, valueProps, props)), [value, props] // eslint-disable-line react-hooks/exhaustive-deps
    );
  };

  WithValue.displayName = displayName(Component);
  return WithValue;
};

/* harmony default export */ __webpack_exports__["default"] = (withValue);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
const capitalize = value => value && value.charAt(0).toUpperCase() + value.slice(1);
const compose = (...functions) => functions.reduceRight((prevFunc, func) => (...args) => func(prevFunc(...args)), arg => arg);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28);
/* harmony import */ var _withValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);



const withValues = (...names) => Object(_lib_utils__WEBPACK_IMPORTED_MODULE_0__["compose"])(...names.map(_withValue__WEBPACK_IMPORTED_MODULE_1__["default"]));

/* harmony default export */ __webpack_exports__["default"] = (withValues);

/***/ })
/******/ ]);
});